// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// Components
import "./components";

// Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";
import VueProgressBar from "vue-progressbar";

Vue.use(VueProgressBar, {
  color: "#2196F3",
  failedColor: "#874b4b",
  thickness: "3px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 3000,
  },
  autoRevert: true,
  inverse: false,
  autoFinish: false,
});

import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["titlebar=no", "scrollbars=yes", "fullscreen=yes"]
};

Vue.use(VueHtmlToPaper, options);

// Application imports
import App from "./App";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";

import vuetify from "@/plugins/vuetify";
// import Vuetify from 'vuetify'
// import theme from './plugins/theme'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'
import "material-design-icons-iconfont/dist/material-design-icons.css";

import VuetifyConfirm from "vuetify-confirm";
Vue.use(VuetifyConfirm, { vuetify });
// import axios from 'axios'

// Vue.prototype.$http = axios

// // Sets the default url used by all of this axios instance's requests
// axios.defaults.baseURL = process.env.VUE_APP_API_URL
// axios.defaults.headers.get['Accept'] = 'application/json'
// //axios.defaults.headers["language"] = "ne"

// const token = localStorage.getItem('token')
// if (token) {
//   axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
// }

// Sync store with router
sync(store, router);

// Vue.use(Vuetify, {
//   iconfont: 'mdi',
//   theme
// })

Vue.config.productionTip = false;

let storedlocale = localStorage.getItem("locale");
if (storedlocale != null) i18n.locale = storedlocale;

/* eslint-disable no-new */
const vue = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

export default vue;
